// extracted by mini-css-extract-plugin
module.exports = {"delete-button":"DeleteButton_delete-button__1df0s","delete-button__disabled":"DeleteButton_delete-button__disabled__1XJY_"};